module.exports = __webpack_public_path__ + "static/media/close-black.57f8d6ce.svg";